module.exports = {
  title: 'Cryptoodles',
  description: 'The official website for the Cryptooodles project and its digital companions called Toodles. Discover the origins and history of a hidden blockchain project as a Blockchain Archaeologist. A blockchain project founded in 2021.',
  keywords: 'cryptoodles, ethereum, blockchain, nft, toodles, bitcoin, ordinals',
  url: 'https://cryptoodles.com',
  twitter: '@cryptoodles',
  seoImage: 'https://www.gitbook.com/cdn-cgi/image/width=40,height=40,fit=contain,dpr=2,format=auto/https%3A%2F%2F857234157-files.gitbook.io%2F~%2Ffiles%2Fv0%2Fb%2Fgitbook-legacy-files%2Fo%2Fspaces%252F-MbZMNv8BaxZA2zLIamL%252Favatar-1633385152911.png%3Fgeneration%3D1633385153384940%26alt%3Dmedia',
  color: '#000000'
};
